var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChev1Down(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2513_5381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2513_5381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 19.9335C15.822 19.9335 15.6553 19.9058 15.4997 19.8502C15.3442 19.7946 15.1997 19.7002 15.0664 19.5669L8.93307 13.4335C8.68863 13.1891 8.56641 12.878 8.56641 12.5002C8.56641 12.1224 8.68863 11.8113 8.93307 11.5669C9.17752 11.3224 9.48863 11.2002 9.86641 11.2002C10.2442 11.2002 10.5553 11.3224 10.7997 11.5669L15.9997 16.7669L21.1997 11.5669C21.4442 11.3224 21.7553 11.2002 22.1331 11.2002C22.5109 11.2002 22.822 11.3224 23.0664 11.5669C23.3109 11.8113 23.4331 12.1224 23.4331 12.5002C23.4331 12.878 23.3109 13.1891 23.0664 13.4335L16.9331 19.5669C16.7997 19.7002 16.6553 19.7946 16.4997 19.8502C16.3442 19.9058 16.1775 19.9335 15.9997 19.9335Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChev1Down);
export default __webpack_public_path__ + "static/media/chev1-down.8c2601380de27b9cba3efef7c1d29db6.svg";
export { ForwardRef as ReactComponent };